import React, { useEffect, useState} from 'react';
import {SelectValidator, TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import ColAtm from "../../../../atomic/Col/Col";
import {FormControl, Grid, InputLabel, MenuItem, Select, TextField, Tooltip, Snackbar} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import InputAtm from "../../../../atomic/Input/Input";
import ButtonAtm from "../../../../atomic/Button/Button";
import {
    updatePlace,
    getPlaceList,
    updatePlaceClearStatus,
    getPlaceCategoryFieldsUpdateClearStatus, getPlaceCategoryFields
} from "../../../../../redux/actions/Content/Places/placesActions"
import {useTranslation} from "react-i18next";
import {Alert} from "@material-ui/lab";
import {convertAccentedCharacters, isDefined, getPropertyName} from "../../../../../utils";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from 'axios';
import { GET_ROOM_DESCRIPTION } from '../../../../../constants/api.constants';
import { getAppLang } from '../../../../../utils';
import { Animated } from 'react-animated-css';
import { openAI, clearOpenAI } from '../../../../../redux/actions/General/OpenAI/openAIActions';
import { makeStyles } from '@material-ui/core/styles';
import { getLanguages } from '../../../../../redux/actions/languageActions';
import { OPEN_AI } from '../../../../../constants/api.constants';
import { getUserToken, getProperty } from '../../../../../utils';
import { propertyProducts } from '../../../../../redux/actions/propertyProductsActions';

const useStyles = makeStyles({
  tooltip: {
    fontSize: '1rem',
    fontWeight: 500,
  },
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`room-rate-tabpanel-${index}`}
            aria-labelledby={`room-rate-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `room-rate-tab-${index}`,
        'aria-controls': `room-rate-tabpanel-${index}`,
    };
}

function a12yProps(index) {
    return {
        id: `place-description-tab-${index}`,
        'aria-controls': `room-rate-tabpanel-${index}`,
    };
}

const findChildData = (data, parentId) => {
    let childData = data.filter( (placesCategories) => {
        return placesCategories.parent_id === parentId
    })
    return childData;
}

const getChildData = (data , childIds) => {
    let childsData = [];

     childIds.forEach( childId => {
        let d = data.filter( (placesCategory) => {

            return placesCategory.parent_id === childId
        });

        childsData.push(d);
    })

    return childsData;
}

const EditPlacesModal = (props) => {

    const placesCategories  = useSelector(props => props.placesGetCategoriesReducer.placesCategories?.place_categories);
    const placeWorkingHours = useSelector(props => props.placesGetCategoriesReducer.placesCategories?.place_working_hours);
    const placeIncludes = useSelector(props => props.placesGetCategoriesReducer.placesCategories?.place_includes);
    const updatePlaceStatus = useSelector(props => props.updatePlaceReducer.updatePlaceStatus?.status);
    const updatePlaceError = useSelector(props => props.updatePlaceReducer.error);
    const updateGetInputsPlaceError = useSelector(props => props.updatePlaceReducer.getCategoryError);
    const placeCategoryFieldsReducer = useSelector(props => props.updatePlaceReducer);
    const placeCategoryFields = isDefined(placeCategoryFieldsReducer.placeCategoryFields.data) && placeCategoryFieldsReducer.placeCategoryFields.data.place_category_fields;
    const openAIResult = useSelector(props => props?.openAIReducer?.listData);
    const languageList = useSelector(state => state.languagesReducer.languages);
    const propertyProductsReducer = useSelector(state => state.propertyProductsReducer);

    const dispatch = useDispatch();
    const classes = useStyles();

    const formRef = React.useRef(null);

    const { t } = useTranslation();

    const [selectedCategory, setSelectedCategory] = useState( props.place.category_filters[ 0 ]);
    const [selectedChildId, setSelectedChildId] = useState(props.place.category_filters.slice(Math.max(props.place.category_filters.length - 2, 1)));
    const [lastSelectedId, setLastSelectedId] = useState( props.place.category_filters[ props.place.category_filters.length-1 ] );
    const [workingHour, setWorkingHour] = useState(props.place.place_working_hour_id);
    const [include, setInclude] = useState(props.place.include);
    const [placeName, setPlaceName] = useState(props.place.name);
    const [isReservation, setIsReservation] = useState(props.place.reservation_requirement);
    const [childData, setChildData] = useState( getChildData(placesCategories, props.place.category_filters.slice(0, props.place.category_filters.length-1) ) );
    const [render, setRender] = useState(false);
    const [descriptionTabValue, setDescriptionTabValue] = React.useState(0);
    const [descriptionMaxCharCount] = React.useState(2000);
    const [descriptionCharCount, setDescriptionCharCount] = React.useState(Object.keys(props.place.description).length > 0  ? props.place.description.map(value =>{
        return value.description === null ? 0 : value.description.length
    }) : []);
    const [status, setStatus] = useState(props.place.status);

    const [state, setState] = useState({
        fields: placeCategoryFields,
        description: props.place.description
    });
    const [langNameState, setLangNameState] = useState({
        fields: placeCategoryFields,
        description: props.place.language_name
    });
    const [placeLanguageName, setPlaceLanguageName] = useState(props.place.language_name);
    const [hasLocaleName, setHasLocaleName] = useState(false);
    const [nameTabValue, setNameTabValue] = React.useState(0);

    const [nameCharCount, setNameCharCount] = React.useState(isDefined(placeLanguageName) && Object.keys(placeLanguageName).length > 0  ? placeLanguageName.map(value =>{
        return value?.name === null ? 0 : value?.name?.length
    }) : []);
    const [nameMaxCharCount] = React.useState(200);
    const [placeLink, setPlaceLink] = useState(props.place?.web);
    const [menuLink, setMenuLink] = useState(props.place?.menu);
    const [enableContactForm, setEnableContactForm] = useState(props.place?.contact_form === null ? 0 : props.place?.contact_form);
    const [aiLoading, setAiLoading] = useState(false);
    const [translateLoading, setTranslateLoading] = useState(false);
    const [isTranslateMode, setIsTranslateMode] = useState(false);
    const [translateSourceLang, setTranslateSourceLang] = useState("");
    const [showSnackbar, setShowSnackbar] = useState(false);

    useEffect(() => {
        if (placeLanguageName?.length < 1) {
            getNullDesc();
        }
    },[]);

    useEffect(() => {
        if (!propertyProductsReducer.get_products) {
            dispatch(propertyProducts());
        }
    }, []);

    useEffect(() => {
        placeLanguageName.map((data => {
            data.name !== null && setHasLocaleName(true)
        }))
    },[]);

    useEffect(() => {
        if (openAIResult && typeof openAIResult === "object" && Object.keys(openAIResult).length > 0) {
            handleAIResponse(openAIResult);
            setAiLoading(false);
        }
    }, [openAIResult]);

    const getNullDesc = () => {  
        axios.get(GET_ROOM_DESCRIPTION, {
          headers: {
            "Accept": "application/json",
            authToken: localStorage.getItem('auth'),
            "Content-Type": "application/json",
            "language": getAppLang(),
          }
        }).then((result) => {
            setPlaceLanguageName(result.data.data)
        }).catch(function (error) {
          console.log(error);
        });
      }

    const handleChange = (event, newValue) => {
        dispatch(getPlaceCategoryFieldsUpdateClearStatus());

        props.setValue(newValue);
    };

    const handleChangeDescriptionTab = (event, newValue) => {
        setDescriptionTabValue(newValue);
    };

    const handleChangeCharCount = index => (e) => {
        let tempCount = descriptionCharCount;
        tempCount[index] = e.target.value.length;

        setDescriptionCharCount(tempCount)

        let values = state.description;
        values[index]['description'] = e.target.value;
        setState({ ...state, values });

    };

    const handleChangeCategory = ({target}) => {
        if(target.value === null) return 0;
        setSelectedCategory(target.value)
        setLastSelectedId(target.value)
        setSelectedChildId([]);
        let childData = findChildData(placesCategories, target.value);
        setChildData( [childData]  )
        setRender(!render)
    }

    const handleChangeChild = (e,index) => {
        if(e.target.value === null) return 0;

        let findedChildData = findChildData(placesCategories,e.target.value)

        if (findedChildData.length === 0 ){
            let temp = childData;
            temp.splice(index+1, temp.length);
            setChildData(temp);
            setLastSelectedId(e.target.value)
            let tempChildIds = selectedChildId;
            tempChildIds.splice(index, tempChildIds.length);
            tempChildIds.push(e.target.value)
            setSelectedChildId(tempChildIds)

            setRender(!render)
            return 0;
        }

        if ((index+1) < childData.length ){

            let temp = childData;
            temp.splice(index+1, temp.length);
            temp.push(findedChildData);
            setLastSelectedId(e.target.value)
            setChildData(temp);

            let tempChildIds = [e.target.value];
            setSelectedChildId(tempChildIds)

        }else{

            setLastSelectedId(e.target.value);
            setChildData(prevState => [...prevState, findedChildData]);
            setSelectedChildId(prevState => [...prevState, e.target.value]);
        }

        setRender(!render)
    }

    const handleChangeWorkingHour = ({target}) => {
        if(target.value === null) return 0;
        setWorkingHour(target.value);
    }

    const handleChangeInclude = ({target}) => {
        if(target.value === null) return 0;
        setInclude(target.value);
    }

    const handleChangeReservation = ({target}) => {
        if(target.value === null) return 0;
        setIsReservation(target.value);
    }

    const handleChangePlaceName = (e) => {
        setPlaceName(e.target.value)
    }

    const handleChangeStatus = (e) => {
        setStatus(e.target.value)
        if (e.target.value === 0) {
            e.preventDefault();
            dispatch(getPlaceCategoryFields(lastSelectedId, props.place.id));
        }
    }

    const handleChangeNameTab = (event, newValue) => {
        setNameTabValue(newValue);
    };

    const handleHasLocaleName = (e) => {
        setHasLocaleName(!hasLocaleName)
    }

    const handleChangePlaceLink = (e) => {
        setPlaceLink(e.target.value);
    }

    const handleChangeMenuLink = (e) => {
        setMenuLink(e.target.value);
    }
    
    const handleEnableContactForm  = ({target}) => {
        if(target.value === null) return 0;
        setEnableContactForm(target.value);
    }

    const handleNameCharCount = index => (e) => {
        let tempCount = nameCharCount;
        tempCount[index] = e.target.value.length;

        setNameCharCount(tempCount)

        let values = placeLanguageName;
        values[index]["name"] = e.target.value === "" ? null : e.target.value;
        setLangNameState({ ...langNameState, values });

    };

    const handleAIResponse = (aiData) => {
        let updatedDescriptions = state.description.map(desc => ({ ...desc }));

        Object.keys(aiData || {}).forEach(lang => {
            const idx = updatedDescriptions.findIndex(d => d.language_code === lang);
            if (idx !== -1 && aiData[lang]) {
                updatedDescriptions[idx].description = aiData[lang];
            }
        });

        setState(prev => ({
            ...prev,
            description: updatedDescriptions
        }));

        setDescriptionCharCount(
            updatedDescriptions.map(d => d.description ? d.description.length : 0)
        );
        dispatch(clearOpenAI());
    };

    const handleAIDescription = index => async (e) => {
        setAiLoading(true);
        setIsTranslateMode(false);

        const langCodes = (languageList || []).filter(lang => lang.name !== "Turkish").map(lang => lang?.name).join(', ');

        let aiMessage = [
            {
                role: "system",
                content: "Sen bir SEO uzmanısın. Cevaplarını SADECE JSON formatında ver, veriye sadece açıklamayı dahil et, object keyleri sadece dil kodu olsun. Otelin Mekanı için özgün, açıklayıcı ve SEO uyumlu açıklamalar üret"
            },
            {
                role: "user",
                content: `Aşağıdaki bilgilerle ${getPropertyName() + " isimli otelin" || "bu otelin"} mekanı için özgün ve SEO uyumlu bir açıklama oluştur: mekanın ismi ${placeName}, mekanın kategorisi ise ${t(placesCategories?.find(c => c.id === selectedCategory)?.language_key || "")}. Açıklama maksimum 300 karakter olsun ve kullanıcıyı bilgilendirici olsun. Şehir bilgisini açıklamada dahil etme. Türkçe dilinde oluştur ve ${langCodes} dillerine çevir.`
            }
        ];  
        dispatch(openAI({ message: aiMessage }));
    };

    const handleTranslate = (index, langCode) => async (e) => {
        const currentDesc = state.description.find(d => d.language_code === langCode);

        if (!currentDesc?.description || currentDesc.description.trim() === "") {
            return;
        }

        setTranslateLoading(true);

        const sourceLangName = (languageList || []).find(lang => lang?.code === langCode)?.name || langCode;

        const targetLangs = (languageList || [])
            .map(lang => ({ code: lang?.code, name: lang?.name }))
            .filter(lang => lang.code);

        const headers = {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        };

        const makeRequest = (targetLang) => {
            const body = {
                params: {
                    property_id: getProperty(),
                    query: {
                        model: "gpt-4.1-mini",
                        response_format: { type: "json_object" },
                        messages: [
                            {
                                role: "system",
                                content: "Sen profesyonel bir çevirmensin. Cevabını SADECE JSON formatında ver, tek bir key olsun: dil kodu (örn: {\"en\": \"...\"})."
                            },
                            {
                                role: "user",
                                content: `Aşağıdaki ${sourceLangName} dilindeki metni ${targetLang.name} diline çevir. Metin: "${currentDesc.description}". Çeviriyi JSON formatında ver, key olarak "${targetLang.code}" kullan.`
                            }
                        ]
                    }
                }
            };
            return axios.post(OPEN_AI, body, { headers })
                .then(res => res.data.data)
                .catch(() => null);
        };

        try {
            const results = await Promise.all(targetLangs.map(lang => makeRequest(lang)));

            // Sonuçları birleştir
            const merged = {};
            results.forEach(result => {
                if (result && typeof result === 'object') {
                    Object.assign(merged, result);
                }
            });

            handleTranslateResponse(merged, langCode);
        } finally {
            setTranslateLoading(false);
        }
    };

    const handleTranslateResponse = (aiData, sourceLangCode) => {
        let updatedDescriptions = state.description.map(desc => ({ ...desc }));

        Object.keys(aiData || {}).forEach(lang => {
            if (lang !== sourceLangCode) {
                const idx = updatedDescriptions.findIndex(d => d.language_code === lang);
                if (idx !== -1 && aiData[lang]) {
                    updatedDescriptions[idx].description = aiData[lang];
                }
            }
        });

        setState(prev => ({
            ...prev,
            description: updatedDescriptions
        }));

        setDescriptionCharCount(
            updatedDescriptions.map(d => d.description ? d.description.length : 0)
        );
        setShowSnackbar(true);
        dispatch(clearOpenAI());
    };

    const sortedLanguageNames = isDefined(placeLanguageName)
        ? placeLanguageName.map((item, idx) => ({ ...item, originalIndex: idx })).sort((a, b) => {
            if (a.language_code === "tr") return -1;
            if (b.language_code === "tr") return 1;
            if (a.language_code === "en") return -1;
            if (b.language_code === "en") return 1;
            return a.language_code.localeCompare(b.language_code);
        })
        : [];

    const nameTabs = sortedLanguageNames.map((title, value) => {
        const flag = (
            <Grid container className="brand-desc-flag" spacing={1}>
                <Grid item sm={3}>
                    <img src={`${process.env.PUBLIC_URL}/assets/img/language/${title.language_code}.svg`} alt={title.language_code} />
                </Grid>
                <Grid item sm={2}>
                    {title.language_code}
                </Grid>
            </Grid>
        );
        return (
            <Tab label={flag} {...a12yProps(value)} key={title.language_code} />
        );
    });

    const nameList = sortedLanguageNames.map((title, index) => {
        return (
            <TabPanel value={nameTabValue} index={index} className="w-100" key={title.language_code}>
                <TextField
                    name={title?.language_code}
                    type="text"
                    variant="outlined"
                    className="text-capitalize"
                    onChange={handleNameCharCount(title.originalIndex)}
                    value={placeLanguageName[title.originalIndex]?.name || ""}
                    label={t('enw-input-place_name') + " - " + title?.language_code}
                    multiline={true}
                    fullWidth
                    required={false}
                    rows={1}
                    inputProps={{ maxLength: nameMaxCharCount }}
                />
                <div style={{ width: '100%' }}>
                    <p style={{ float: 'right' }}> {nameCharCount[title.originalIndex]}/ {nameMaxCharCount}</p>
                </div>
            </TabPanel>
        );
    });

    useEffect( ()=> {
        if ( (updatePlaceStatus === 200) ){

            // List Yeniden Çekilecek
            dispatch(getPlaceList());

            //Modal Kapatılacak ;
            props.closePlace();

            // Status temizleniyor
            dispatch(updatePlaceClearStatus());
        } else {
            props.setValue(0)
        }

    },[render, updatePlaceStatus,updatePlaceError] )

    useEffect( ()=> {

        if (placeCategoryFieldsReducer.placeCategoryFields.status === 200) {
            setState( { ...state, fields: placeCategoryFields })
            props.setValue(1)
        }
        if (status === 0) {
            props.setValue(0)
        }
        
    },[render, placeCategoryFieldsReducer, updateGetInputsPlaceError] )

    const onSubmit = (e) => {
        e.preventDefault();
        if (hasLocaleName === false) {
            placeLanguageName.map((data => {
                data.name = null;
            }))
        }

        let params = {
            property_place_id: props.place.id,
            place_category_id: lastSelectedId,
            place_working_hour_id: workingHour,
            name : placeName,
            include: include,
            reservation_requirement : isReservation ? 1 : 0,
            field_values: state.fields,
            description: state.description,
            status: status,
            language_name: placeLanguageName,
            web: placeLink || null,
            menu: (selectedCategory === 1 || selectedCategory === 130 || selectedCategory === 133) ? menuLink : null,
            contact_form: enableContactForm ? 1 : 0
        }

        dispatch(updatePlace(params));
    };

    const getFields = (e) => {
        if (e) e.preventDefault();
        dispatch(getPlaceCategoryFields(lastSelectedId, props.place.id));
    };

    const handleChangeFields = (e, key, type, value, name) => {
        let values = state.fields;

        if (type === "multi") {
            let selectedValues =  value.map((item) => {return item.option_id})

            values[key]['field_id'] = key;
            values[key]['field_value'] = selectedValues;
            values[key]['field_name'] = name;
        }
        else if (type === "firstSlider") {
            values[key]['field_id'] = key;
            values[key]['field_value'][0] = e.target.value;
            values[key]['field_name'] = name;
        }
        else if (type === "secondSlider") {
            values[key]['field_id'] = key;
            values[key]['field_value'][1] = e.target.value;
            values[key]['field_name'] = name;
        }
        else if (type === "inputunit") {
            values[key]['field_id'] = key;
            values[key]['field_value'] = e.target.value;
            values[key]['field_name'] = e.target.name;
        }
        else if (type === "unitSelect") {
            values[key]['field_unit_value'] = e.target.value;
            values[key+"_unit"]['field_unit_value'] = e.target.value;
        }
        else {
            values[key]['field_id'] = key;
            values[key]['field_value'] = e.target.value;
            values[key]['field_name'] = e.target.name;
        }
        setState({ ...state, values });
    };

    const contentProduct = !propertyProductsReducer.fetching &&
        isDefined(propertyProductsReducer.get_products)
            ? Object.values(propertyProductsReducer.get_products.data).find(item => item.route === "content")
            : null;

    const showAIContent = isDefined(contentProduct) &&
        isDefined(contentProduct.parameters) &&
        (contentProduct.parameters.length === 0 || contentProduct.parameters.some(p => p?.product_parameter_id === 102 && p?.is_selected === 1));

    const sysLang = getAppLang();
    const sortedDescriptions = state.description.map((item, idx) => ({ ...item, originalIndex: idx })).sort((a, b) => {
        // Önce tr, sonra en gelsin
        if (a.language_code === "tr") return -1;
        if (b.language_code === "tr") return 1;
        if (a.language_code === "en") return -1;
        if (b.language_code === "en") return 1;
        // Diğer diller alfabetik
        return a.language_code.localeCompare(b.language_code);
    });

    const descriptionList = sortedDescriptions?.map((title, index)=>{
        const hasDescription = title?.description && title?.description.trim() !== "";
        return (
            <TabPanel value={descriptionTabValue} index={index} className="w-100">
                {showAIContent && (
                    <Box display="flex" justifyContent="flex-end" mb={1} style={{ gap: 8 }}>
                        <Tooltip title={placeName === "" || placeName === undefined ? t('enw-ai_place_name_required') : t('enw-create_with_ai-title')} classes={{ tooltip: classes.tooltip }} arrow>
                            <span>
                                <ButtonAtm
                                    size="small"
                                    variant="outlined"
                                    onClick={handleAIDescription(title.originalIndex)}
                                    startIcon={
                                    aiLoading ? 
                                        <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" style={{color: "#d71f26", marginLeft: "8px"}} className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                                            <path d="M20 3v4"></path>
                                            <path d="M22 5h-4"></path>
                                            <path d="M4 17v2"></path>
                                            <path d="M5 18H3"></path>
                                        </svg>
                                    }
                                    className="mt-12 create-with-ai"
                                    style={{borderRadius: "8px", color: "#000", textTransform: "none"}}
                                    buttontext={t('enw-create_with_ai-title')}
                                    disabled={placeName === "" || placeName === undefined || aiLoading || translateLoading}
                                />
                            </span>
                        </Tooltip>
                        <ButtonAtm
                            size="small"
                            variant="outlined"
                            onClick={handleTranslate(title.originalIndex, title.language_code)}
                            startIcon={
                                translateLoading ?
                                    <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                    :
                                    <svg fill="#d71f26" style={{width: "1.5rem", height: "1rem", fontSize: 20, marginLeft: "8px"}} viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/>
                                    </svg>
                            }
                            className="mt-12"
                            style={{borderRadius: "8px", color: "#000", textTransform: "none"}}
                            buttontext={t('btn-translate')}
                            disabled={!hasDescription || aiLoading || translateLoading}
                        />
                    </Box>
                )}
                <TextField
                    name={title.language_code}
                    type="text"
                    variant="outlined"
                    className={showAIContent ? 'text-capitalize mt-0' : 'text-capitalize mt-10' }
                    onChange={handleChangeCharCount(title.originalIndex)}
                    value={state.description[title.originalIndex]?.description || ""}
                    label={ t('enw-input-description') + " - " + title.language_code }
                    multiline={true}
                    fullWidth
                    required={false}
                    rows={2}
                    inputProps={{maxLength : descriptionMaxCharCount}}
                />
                <div style={{ width: '100%'}}>
                    <p style={{ float : 'right'}}> { descriptionCharCount[title.originalIndex] }/ {descriptionMaxCharCount}</p>
                </div>
            </TabPanel>
        );
    })

    const descriptionTabs = sortedDescriptions?.map((title, value) => {
        const flag = (
            <Grid container className="brand-desc-flag" spacing={1}>
                <Grid item sm={3}>
                    <img src={`${process.env.PUBLIC_URL}/assets/img/language/${title.language_code}.svg`} alt={title.language_code} />
                </Grid>
                <Grid item sm={2}>
                    {title.language_code}
                </Grid>
            </Grid>
        );
        return (
            <Tab label={flag} {...a12yProps(value)} />
        );
    });

    return (
        <div>
            <style>{`
                button.Mui-disabled {
                    color:#000 !important;
                }
            `}</style>
            <ValidatorForm onSubmit={getFields} ref={formRef} onError={errors => console.log(errors)}>
                <AppBar className="room-rate-tab-title" position="static">
                    <Tabs className="room-rate-tabFont" value={props.value} onChange={handleChange} aria-label="room-rate-tab">
                        <Tab label={ t('enw-content-place_details-title') } {...a11yProps(0)} />
                        <ButtonAtm
                            className={props.value === 1 ? "bed-type-title" : "passive-tab"}
                            buttontext={ t('enw-content-place_facts-add_place-title') }
                            onClick={(e) => {
                                e.preventDefault();
                                if (formRef.current) {
                                    formRef.current.submit();
                                }
                            }}
                        />
                    </Tabs>
                </AppBar>
                <TabPanel value={props.value} index={0}>
                    <ColAtm xs={12} className="select-room-types">
                        {isDefined(updatePlaceError?.response) && <Alert className="w-100 mt-22" severity="error">{updatePlaceError?.response?.data?.message}</Alert>}
                        {isDefined(updateGetInputsPlaceError?.response) && <Alert className="w-100 mt-22" severity="error">{updateGetInputsPlaceError?.response?.data?.message}</Alert>}
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeCategory}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                label={ t('enw-content-place_categories') }
                                value={selectedCategory}
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                {
                                    placesCategories.length > 0 && placesCategories.filter( (placesCategories) => {
                                        return placesCategories.parent_id === null
                                    }).map((category) => (
                                        <MenuItem value={category.id} >
                                            { t(category.language_key) }
                                        </MenuItem>
                                    ))
                                }
                            </SelectValidator>
                        </ColAtm>
                        {
                            childData.length > 0 && childData.map( (item,key) => (
                                <ColAtm xs={12} className="form-group">
                                    <SelectValidator
                                        onChange={(e) => handleChangeChild(e,key)}
                                        className="form-control"
                                        variant="outlined"
                                        fullWidth
                                        label={ t('enw-input-category_type') }
                                        value={selectedChildId[key]}
                                        validators={['required']}
                                        errorMessages={[ t("enw-notification_this_is_required") ]}
                                    >
                                        {
                                            item.map((category) => (
                                                <MenuItem value={category.id} >
                                                    { t(category.language_key) }
                                                </MenuItem>
                                            ))
                                        }
                                    </SelectValidator>
                                </ColAtm>
                            ))
                        }
                        <ColAtm xs={12} className="form-group">
                            <TextValidator
                                label={ t('enw-input-place_name') }
                                name="place_name"
                                type="text"
                                fullWidth
                                value={placeName}
                                onChange={handleChangePlaceName}
                                autoComplete="off"
                                variant="outlined"
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            />
                        </ColAtm>
                        <label onClick={handleHasLocaleName} style={{marginBottom: "6px"}} className={"traditional-name " + ( hasLocaleName ? 'active-button' : '')} htmlFor="haveANonEnglishName">
                        <i className={ hasLocaleName ? 'fa fa-check' : ''} aria-hidden="true" />
                        { t('enw-btn-place_have_local_name')}
                        </label>
                        {   
                            hasLocaleName && 
                            <Animated animationIn="fadeIn" style={{width:"100%"}} animationInDuration={1000} isVisible={true}>
                                <ColAtm className="d-block brand-container place-desc mb-0">
                                    <ColAtm>
                                        <AppBar className="room-rate-tab-title" position="static">
                                            <Tabs className="room-rate-tabFont"
                                                value={nameTabValue}
                                                onChange={handleChangeNameTab}
                                                aria-label="place-description-tab"
                                                variant="scrollable"
                                                scrollButtons="on"
                                            >
                                                {nameTabs}
                                            </Tabs>
                                        </AppBar>
                                        {nameList}
                                    </ColAtm>
                                </ColAtm>
                            </Animated>
                        }
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeWorkingHour}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={workingHour}
                                label={ t('enw-input-working_hour') }
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                {
                                    placeWorkingHours.length > 0 && placeWorkingHours.map( (placesWorkingHour) => (
                                        <MenuItem value={placesWorkingHour.id} >
                                            { t(placesWorkingHour.language_key) }
                                        </MenuItem>
                                    ))
                                }
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeInclude}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={include}
                                label={ t('enw-input-include') }
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                {
                                    placeIncludes.length > 0 && placeIncludes.map( (placeInclude) => (
                                        <MenuItem value={placeInclude.id} >
                                            { t(placeInclude.language_key) }
                                        </MenuItem>
                                    ))
                                }
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeStatus}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={status}
                                label={ t('enw-content-status') }
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                <MenuItem value={0} >
                                    { t('enw-input-inactive') }
                                </MenuItem>
                                <MenuItem value={1} >
                                    { t('enw-input-active') }
                                </MenuItem>
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeReservation}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={isReservation}
                                label={ t('enw-content-add_place-is_reservation_required') }
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                <MenuItem value={0} >
                                    { t('enw-input-checkbox-no') }
                                </MenuItem>
                                <MenuItem value={1} >
                                    { t('enw-input-checkbox-yes') }
                                </MenuItem>
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm xs={12} className="form-group">
                            <TextValidator
                                label={ t('enw-input-place_link') }
                                name="place_link"
                                type="text"
                                fullWidth
                                autoComplete="off"
                                value={placeLink}
                                onChange={handleChangePlaceLink}
                                variant="outlined"
                                validators={['matchRegexp:^(https?:\\/\\/)?((([-a-z0-9]{1,63}\\.)*?[a-z0-9]([-a-z0-9]{0,253}[a-z0-9])?\\.[a-z]{2,63})|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d{1,5})?((\\/|\\?)((%[0-9a-f]{2})|[-\\w\\+\\.\\?\\/@~#&=])*)?$']}
                                errorMessages={[ t("enw-input-place_link-validation_error") ]}
                            />
                        </ColAtm>
                        {
                            selectedCategory && (selectedCategory === 1 || selectedCategory === 130 || selectedCategory === 133) &&
                            <ColAtm xs={12} className="form-group">
                                <TextValidator
                                    label={ t('enw-input-menu_link') }
                                    name="menu_link"
                                    type="text"
                                    fullWidth
                                    autoComplete="off"
                                    value={menuLink}
                                    onChange={handleChangeMenuLink}
                                    variant="outlined"
                                    validators={['matchRegexp:^(https?:\\/\\/)?((([-a-z0-9]{1,63}\\.)*?[a-z0-9]([-a-z0-9]{0,253}[a-z0-9])?\\.[a-z]{2,63})|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d{1,5})?((\\/|\\?)((%[0-9a-f]{2})|[-\\w\\+\\.\\?\\/@~#&=])*)?$']}
                                    errorMessages={[ t("enw-input-place_link-validation_error") ]}
                                />
                            </ColAtm>
                        }
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleEnableContactForm}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={enableContactForm}
                                label={ t('myweb-contact-contact_form-title') }
                            >
                                <MenuItem value={0} >
                                    { t('enw-input-checkbox-no') }
                                </MenuItem>
                                <MenuItem value={1} >
                                    { t('enw-input-checkbox-yes') }
                                </MenuItem>
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm className="d-block brand-container place-desc">
                            <ColAtm>
                                <AppBar className="room-rate-tab-title" position="static">
                                    <Tabs className="room-rate-tabFont"
                                          value={descriptionTabValue}
                                          onChange={handleChangeDescriptionTab}
                                          aria-label="place-description-tab"
                                          variant="scrollable"
                                          scrollButtons="on"
                                    >
                                        {descriptionTabs}
                                    </Tabs>
                                </AppBar>
                                {descriptionList}
                            </ColAtm>
                        </ColAtm>
                        <ColAtm className="mt-13" md={12}>
                        {
                            status === 1 ?
                        
                            <ButtonAtm
                                className="m-auto room-rate-modal-save bg-red"
                                type="submit"
                                buttontext={ t('btn-next') }
                                color="primary"
                            />
                            : 
                            
                            <ButtonAtm
                            className="m-auto room-rate-modal-save bg-red"
                            type="submit"
                            buttontext={ t('btn-save') }
                            color="primary"
                            onClick={onSubmit}
                            />
                            
                        }
                            {/* <ButtonAtm
                                    className="m-auto room-rate-modal-save bg-red"
                                    type="submit"
                                    buttontext={ t('btn-next') }
                                    color="primary"
                                /> */}
                        </ColAtm>
                    </ColAtm>
                </TabPanel>
                <TabPanel value={props.value} index={1} className="mt-22">
                    {Object.values(placeCategoryFields).sort((a, b) => a.field_order_number > b.field_order_number ? 1:-1).map((field)=> {
                        return <ColAtm xs={12} className="select-room-types">
                            {
                                field.field_element === "input" ?
                                <ColAtm xs={12} className="form-group">
                                        <InputAtm
                                            name={field.field_name}
                                            type={field.field_type === "text" ? field.field_type : ""}
                                            variant="outlined"
                                            value={field.field_value}
                                            autoComplete="off"
                                            onInput={field.field_type === "number" ? (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') } : ""}
                                            label={ t(field.field_language_key) }
                                            onChange={(e) => handleChangeFields(e, field.field_id, "single")}
                                        />
                                    </ColAtm>
                                :
                                field.field_element === "select" ?
                                <ColAtm xs={12} className="form-group">
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel>{ t(field.field_language_key) }</InputLabel>
                                                <Select
                                                    className="form-control"
                                                    name={field.field_name}
                                                    variant="outlined"
                                                    fullWidth
                                                    value={field.field_value}
                                                    label={ t(field.field_language_key) }
                                                    onChange={(e) => handleChangeFields(e, field.field_id, "single")}
                                                >
                                                    {
                                                        Object.values(field.options).map( (options,index) => (
                                                            <MenuItem value={options.option_id}>
                                                                { t(options.option_language_key) }
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </ColAtm>
                                :
                                field.field_element === "slider" ?
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <TextValidator
                                            label={t('enw-input-min_age')}
                                            name="place_name"
                                            type="text"
                                            fullWidth
                                            autoComplete="off"
                                            value={field.field_value[0]}
                                            onChange={(e, value) => handleChangeFields(e, field.field_id, "firstSlider", value, field.field_name)}
                                            variant="outlined"
                                            /*validators={['minNumber:' + field.field_attribute.slider.min, 'maxNumber:' + field.field_value[1]]}
                                            errorMessages={[ 'minNumber:' + field.field_attribute.slider.min, 'maxNumber:' + field.field_value[1]]}*/
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextValidator
                                            label={t('enw-input-max_age')}
                                            name="place_name"
                                            type="text"
                                            fullWidth
                                            autoComplete="off"
                                            value={field.field_value[1]}
                                            onChange={(e, value) => handleChangeFields(e, field.field_id, "secondSlider", value, field.field_name)}
                                            variant="outlined"
                                            /*validators={['minNumber:' + field.field_value[0], 'maxNumber:' + field.field_attribute.slider.max]}
                                            errorMessages={[ 'minNumber:' + field.field_value[0], 'maxNumber:' + field.field_attribute.slider.max]}*/
                                        />
                                    </Grid>

                                    {/* <Slider
                                    step={field.field_attribute.slider.step}
                                    min={field.field_attribute.slider.min}
                                    max={field.field_attribute.slider.max}
                                    onChange={(e, value) => handleChangeFields(e, field.field_id, "slider", value, field.field_name)}
                                    valueLabelDisplay="auto"
                                    aria-labelledby="range-slider"
                                    defaultValue={(isDefined(field.field_value) && field.field_value !== []  && field.field_value !== "[]" && field.field_value.length > 0) ?
                                        [parseInt(field.field_value[0]), parseInt(field.field_value[1])]
                                        :
                                        [field.field_attribute.slider.min, field.field_attribute.slider.max]
                                    }
                                />*/}
                                </Grid>
                                :
                                field.field_element === "multiselect" ?
                                <ColAtm xs={12} className="form-group">
                                    <Autocomplete
                                        id="placesMulti"
                                        options={Object.values(field.options).sort((a, b) => convertAccentedCharacters(t(a.language_key)) > convertAccentedCharacters(t(b.language_key)) ? 1:-1)}
                                        getOptionLabel={option => t(option.option_language_key)}
                                        defaultValue={Object.values(field.options).filter(single => single.option_is_selected === true)}
                                        multiple
                                        name={field.field_name}
                                        className="w-100"
                                        filterSelectedOptions
                                        onChange={(e, value) => handleChangeFields(e, field.field_id, "multi", value, field.field_name)}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                name={params.field_name}
                                                label={ t(field.field_language_key) }
                                                placeholder={ t(field.field_language_key) }
                                                fullWidth
                                            />
                                        )}
                                    />
                                </ColAtm>
                                :
                                field.field_element === "inputunit" ?
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={8}>
                                        <InputAtm
                                            name={field.field_name}
                                            value={field.field_value}
                                            type={field.field_type === "text" ? field.field_type : ""}
                                            variant="outlined"
                                            autoComplete="off"
                                            onInput={field.field_type === "number" ? (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') } : ""}
                                            label={ t(field.field_language_key) }
                                            onChange={(e) => handleChangeFields(e, field.field_id, "inputunit", "unitInputValue")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4} className="form-group">
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel>{ t(field.field_attribute.unit_label) }</InputLabel>
                                            <Select
                                                className="form-control"
                                                name={field.field_name}
                                                variant="outlined"
                                                value={field.field_unit_value}
                                                fullWidth
                                                label={ t(field.field_attribute.unit_label) }
                                                onChange={(e) => handleChangeFields(e, field.field_id, "unitSelect", "unitSelectValue")}
                                            >
                                                {
                                                    field.field_units.map( (options, index) => (
                                                        <MenuItem value={options.id}>
                                                            { t(options.language_key) }
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                :
                                <></>
                            }
                        </ColAtm>
                    })}
                    <ColAtm className="mt-22" md={12}>
                        <ButtonAtm
                            className="m-auto room-rate-modal-save bg-red"
                            type="submit"
                            buttontext={ t('btn-save') }
                            color="primary"
                            onClick={onSubmit}
                        />
                    </ColAtm>
                </TabPanel>
            </ValidatorForm>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={showSnackbar}
                autoHideDuration={3000}
                onClose={() => setShowSnackbar(false)}
                // style={{ bottom: 80, right: 40, left: 'auto' }}
            >
                <Alert onClose={() => setShowSnackbar(false)} severity="success">
                    {t('enw-translated_to_all_languages')}
                </Alert>
            </Snackbar>
        </div>
    );

}

export default EditPlacesModal;
